import { render, staticRenderFns } from "./SystemConfigBase.vue?vue&type=template&id=6373309e&"
import script from "./SystemConfigBase.vue?vue&type=script&lang=js&"
export * from "./SystemConfigBase.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports